import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

export default function CheckoutForm() {
  const stripe = useStripe();
  const elements = useElements();

  //const [message, setMessage] = useState(null);
  const [message, setMessage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!stripe) {
      return;
    }

  


    const clientSecret = new URLSearchParams(window.location.search).get(
      "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"
    );

    const clientSecret1 = new URLSearchParams(window.location.search).get(
      "sk_test_51OsttB02aqrDZQO72rPQmXGCAvb5K0PFBT8DKQyzOlFgB0nY6npslg9k819rwkoYiC0YPMU0TnBvY54KDm3YNVDw00zFVrijTs"
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
        switch (paymentIntent?.status) { // Using optional chaining (?.)
          case "succeeded":
            setMessage("Payment succeeded!");
            break;
          case "requires_action":
            setMessage("Additional action required");
            break;
          case "requires_payment_method":
            setMessage("Payment method requires updating");
            break;
          default:
            setMessage("Payment failed");
        }
      });
  }, [stripe]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: "https://shiphub.ikeocean.com/portal/payment-success",
      },
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message ?? null); // Convert undefined to null using nullish coalescing operator (??)
      } else {
        setMessage("An unexpected error occurred.");
      }

    setIsLoading(false);
  };

  const paymentElementOptions = {
        layout: "tabs"
  };

 
  return (
    <form id="payment-form" onSubmit={handleSubmit} autoComplete="off">

      <PaymentElement id="payment-element"  />
      
      <button disabled={isLoading || !stripe || !elements} id="submit">
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
        </span>
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
}